import { GetAllClientsForCoBroker } from '../../api/Clients/getAllClientsForCoBrokers.api';
import { GetAllSalesAgentsClient } from '../../api/Clients/getAllSalesAgentsClient.api';
import { GetAllVisibleClients } from '../../api/Clients/getAllVisibleClient.api';
import getCoBrokersSalesAgent from '../../api/Clients/getCoBrokerSalesAgent.api';
import { handleDocument } from '../../api/Clients/handleDocument.api';
import firebase from '../../lib/firebase.prod';
import {
	GET_ALL_SALES_AGENT_CLIENTS,
	GET_ALL_VISIBLE_CLIENTS,
	GET_CLIENTS_FAIL,
	HANDLE_DOC_SUCCESS,
	GET_CO_BROKER_SALES_AGENT,
} from './types';

export const getVisibleClients = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const userType = state.signIn.userType;

		try {
			if (userType === 'superadmin') {
				GetAllSalesAgentsClient((visibleClients) => {
					dispatch(allVisibleClientSuccess(visibleClients));
				});
			} else if (userType === 'admin') {
				GetAllVisibleClients((visibleClients) => {
					dispatch(allVisibleClientSuccess(visibleClients));
				});
			} else if (userType === 'cobroker') {
				GetAllClientsForCoBroker((visibleClients) => {
					dispatch(allVisibleClientSuccess(visibleClients));
				});

				getCoBrokersSalesAgent().then((salesAgent) => {
					console.log('salesAgensalesAgentsalesAgentt', salesAgent);
					dispatch(getCoBrokerSalesAgentSuccess(salesAgent));
				});
			}
		} catch (error) {
			dispatch(loadingFail());
		}
	};
};

export const handleDoc = (
	clientName,
	clientEmailData,
	appCode,
	expand,
	lotId
) => {
	return async (dispatch) => {
		try {
			const documentDetails = await handleDocument(
				clientName,
				clientEmailData,
				appCode,
				expand,
				lotId
			);
			dispatch(handleDocSuccess(documentDetails));
		} catch (error) {
			dispatch(loadingFail());
		}
	};
};

const allVisibleClientSuccess = (payload) => ({
	type: GET_ALL_VISIBLE_CLIENTS,
	payload,
});

const getCoBrokerSalesAgentSuccess = (payload) => ({
	type: GET_CO_BROKER_SALES_AGENT,
	payload,
});

const handleDocSuccess = (payload) => ({
	type: HANDLE_DOC_SUCCESS,
	payload,
});

const loadingFail = () => ({
	type: GET_CLIENTS_FAIL,
});
